import React from 'react';

const Gallery = () => {
  const images = [
    {
      url: 'https://customer-assets.emergentagent.com/job_kozlowski-fit/artifacts/z4uposct_59376984-7a22-4d6c-8770-b993068d7072.jpg',
      alt: 'Paweł Kozłowski - Trening w siłowni'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_kozlowski-fit/artifacts/1pm7j1kx_78ed630f-da8e-4c26-8cf5-15c83510b076.jpg',
      alt: 'Paweł Kozłowski - Trening fitness'
    }
  ];

  return (
    <section className="gallery-section" id="gallery">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Galeria</h2>
          <p className="section-description">
            To są zdjęcia po intensywnym treningu
          </p>
        </div>
        <div className="gallery-grid">
          {images.map((image, index) => (
            <div key={index} className="gallery-item">
              <img 
                src={image.url} 
                alt={image.alt}
                loading="lazy"
              />
              <div className="gallery-overlay">
                <span className="gallery-icon">💪</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
